import { Theme } from "@emotion/react";
import {
  FormControl,
  Grid,
  SxProps,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { useState } from "react";
import { Controller, FieldError } from "react-hook-form";

import { gridSize } from "@/shared/constants/ui.constants";

type CustomTextFieldProps = {
  label: string;
  error: FieldError | undefined | boolean;
  helperText: React.ReactNode;
  disabled?: boolean;
  shrink?: boolean;
  required?: boolean;
  readonly?: boolean;

  type?:
  | React.HTMLInputTypeAttribute
  | "latitud"
  | "longitud"
  | "texto_sin_numeros"
  | "email"
  | "coordenada"
  | "direccion"
  | "numeroFactura"
  | "numeroRemision"
  | "ipv4"
  | "none"
  | "number"
  | "password"
  | "lower";
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  register?: TextFieldProps;

  control?: any;
  name: string;
  defaultValue?: string | number | null;
  onChangeValue?: (value: any, valid?: boolean) => void;

  sizeTextField?: "medium" | "small";
  startAdornment?: React.ReactNode;

  sxTextField?: SxProps<Theme>;

  placeholder?: string;

  overrideAsPassword?: boolean;
  endAdornmentInput?: React.ReactNode;

  //send with enter
  enableToSubmitWithEnter?: boolean;
  handleSubmit?: () => void;
};

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  label,
  error,
  helperText,
  required = true,
  disabled = false,
  shrink = false,
  size = gridSize,
  type = "text",
  control,
  name,
  defaultValue,
  onChangeValue,
  sizeTextField = "medium",

  startAdornment,
  sxTextField,

  placeholder,
  overrideAsPassword,
  endAdornmentInput,

  //send with enter
  enableToSubmitWithEnter = false,
  handleSubmit = () => null,
}) => {
  const [errorAux, setErrorAux] = useState<boolean>(!!error);

  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue ?? ''}
          render={({ field }) => {
            const onChange = (event: any) => {
              let currentValue = event.target.value;

              ///validaciones para latitud
              let valido = false;
              const latitudRegex =
                /^(-?[1-8]?\d(?:\.\d{1,8})?|90(?:\.0{1,8})?)$/;
              const longitudRegex =
                /^-?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

              //// validaciones para latitud
              if (type === "latitud") {
                if (currentValue.length === 0) field.onChange("");
                if (!/^[0-9,.-]+$/.test(currentValue)) return;
                if (latitudRegex.test(currentValue)) {
                  valido = true;
                  setErrorAux(false);
                } else {
                  helperText =
                    'Ingresar una coordenada válida por ejemplo: "-0.3142,-78.4702"';
                  setErrorAux(true);
                }
              }

              /// validaciones para longitud
              if (type === "longitud") {
                if (currentValue.length === 0) field.onChange("");
                if (!/^[0-9,.-]+$/.test(currentValue)) return;
                if (longitudRegex.test(currentValue)) {
                  valido = true;
                  setErrorAux(false);
                } else {
                  helperText =
                    'Ingresar una coordenada válida por ejemplo: "-0.3142,-78.4702"';
                  setErrorAux(true);
                }
              }

              if (type === "texto_sin_numeros") {
                const isText = /^[\p{L}\s]+$/u;
                if (currentValue.length == 0) return field.onChange("");
                if (!isText.test(currentValue)) return;
              }

              if (type === "email") {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(currentValue)) {
                  helperText = "Ingresar un correo electronico válido";
                  setErrorAux(true);
                } else {
                  setErrorAux(false);
                }
                onChangeValue && onChangeValue(currentValue);
                return field.onChange(currentValue.replace(/\s+/g, ""));
              }

              if (type === "coordenada") {
                const clean = currentValue.replace(/\s+/g, "");
                currentValue = clean;
                if (currentValue.length == 0) field.onChange("");
                if (!/^[0-9,.-]+$/.test(currentValue)) return;
                const coordinatePattern =
                  /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),[-+]?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?)$/;
                if (coordinatePattern.test(currentValue)) {
                  valido = true;
                  setErrorAux(false);
                } else {
                  helperText =
                    'Ingresar una coordenada valida por ejemplo: "-0.3142,-78.4702"';
                  setErrorAux(true);
                }
              }

              if (type === "direccion") {
                if (currentValue.length >= 250) {
                  helperText =
                    "La dirección debe tener menos de 250 caracteres";
                  setErrorAux(true);
                  return;
                } else {
                  setErrorAux(false);
                  onChangeValue && onChangeValue(currentValue);
                  return field.onChange(currentValue);
                }
              }
              if (type === "numeroFactura") {

                const soloNumeros = currentValue.replace(/\D/g, "");
                let formateado = soloNumeros;

                if (soloNumeros === "") {
                  onChangeValue && onChangeValue("");
                  field.onChange("");
                  setErrorAux(false)
                  return;
                }

                if (soloNumeros.length > 3 && soloNumeros.length <= 6) {
                  //formateado
                  formateado = `${soloNumeros.slice(0, 3)}-${soloNumeros.slice(3)}`;
                } else if (soloNumeros.length > 6) {
                  formateado = `${soloNumeros.slice(0, 3)}-${soloNumeros.slice(3, 6)}-${soloNumeros.slice(6, 15)}`;
                }

                onChangeValue && onChangeValue(formateado)
                field.onChange(formateado)

                const isFactura = /^\d{3}-\d{3}-\d{9}$/;
                if (!isFactura.test(formateado)) {
                  helperText = "Formato válido. Ej: 001-001-000123456 (15 dígitos)"
                  setErrorAux(true);
                  return;
                } else {
                  setErrorAux(false)
                }
                return;
              }

              if (type === "numeroRemision") {
                const soloNumeros = currentValue.replace(/\D/g, "")
                let formateado = soloNumeros;

                if (soloNumeros === "") {
                  onChangeValue && onChangeValue("");
                  field.onChange("");
                  setErrorAux(false)
                  return;
                }

                if (soloNumeros.length > 3 && soloNumeros.length <= 6) {

                  formateado = `${soloNumeros.slice(0, 3)}-${soloNumeros.slice(3)}`;

                } else if (soloNumeros.length > 6 && soloNumeros.length <= 9) {
                  formateado = `${soloNumeros.slice(0, 3)}-${soloNumeros.slice(3, 6)}-${soloNumeros.slice(6, 15)}`;
                } else if (soloNumeros.length > 9) {

                  formateado = `${soloNumeros.slice(0, 3)}-${soloNumeros.slice(3, 6)}-${soloNumeros.slice(6, 15)}`;
                }

                onChangeValue && onChangeValue(formateado)
                field.onChange(formateado)

                const isRemisionValido = /^\d{3}-\d{3}-\d{7,9}$/;
                if (!isRemisionValido.test(formateado)) {
                  helperText = "Formato válido. Ej: 001-001-000123456 (13 a 15 dígitos)"
                  setErrorAux(true);
                  return;
                } else {
                  setErrorAux(false)
                }
                return;
              }

              if (type === "ipv4") {
                const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
                if (!ipv4Regex.test(currentValue)) {
                  helperText = "Ingresar una dirección IP válida";
                  setErrorAux(true);
                } else {
                  setErrorAux(false);
                }
                onChangeValue && onChangeValue(currentValue);
                return field.onChange(currentValue.replace(/\s+/g, ""));
              }

              // Dinero: solo dígitos + un separador decimal. Acepta coma o punto
              // (normaliza a punto), máximo 2 decimales; descarta letras/símbolos.
              if (type === "moneda") {
                let v = String(currentValue)
                  .replace(/[^0-9.,]/g, "")
                  .replace(/,/g, ".");
                const firstDot = v.indexOf(".");
                if (firstDot !== -1) {
                  v =
                    v.slice(0, firstDot + 1) +
                    v.slice(firstDot + 1).replace(/\./g, "").slice(0, 2);
                }
                onChangeValue && onChangeValue(v);
                return field.onChange(v);
              }

              // Entero: solo dígitos (sin decimales, letras ni símbolos).
              if (type === "entero") {
                const v = String(currentValue).replace(/[^0-9]/g, "");
                onChangeValue && onChangeValue(v);
                return field.onChange(v);
              }

              if (
                type === "none" ||
                type === "number" ||
                type === "password" ||
                type === "lower" ||
                overrideAsPassword
              ) {
                onChangeValue && onChangeValue(currentValue);
                return field.onChange(currentValue);
              }

              field.onChange(currentValue.toUpperCase());
              onChangeValue &&
                onChangeValue(currentValue?.toUpperCase(), valido);
            };

            const onKeyDown = (_event: any) => {
              enableToSubmitWithEnter
                ? _event.key === "Enter"
                  ? // console.log('Enter key pressed')
                  handleSubmit()
                  : null
                : null;
            };

            return (
              <TextField
                {...field}
                disabled={disabled}
                size={sizeTextField}
                fullWidth
                variant="outlined"
                label={label}
                InputLabelProps={{
                  ...(shrink && { shrink: true }),
                }}
                InputProps={{
                  ...(endAdornmentInput && {
                    endAdornment: endAdornmentInput,
                  }),
                  startAdornment: startAdornment ?? null,
                }}
                error={errorAux || !!error}
                placeholder={placeholder ?? ""}
                helperText={helperText}
                type={type}
                onChange={onChange}
                required={required}
                inputProps={{ readOnly: disabled }}
                autoComplete="off"
                autoCorrect="off"
                sx={{
                  ...(disabled
                    ? {
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "rgba(0, 0, 0, 0.035)",
                        cursor: "not-allowed",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(239, 239, 239, 0.16)",
                          borderStyle: "dashed",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(0, 0, 0, 0.22)",
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "rgba(15, 23, 42, 0.88)",
                        color: "rgba(15, 23, 42, 0.88)",
                        fontWeight: 600,
                        cursor: "not-allowed",
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "text.secondary",
                        fontWeight: 500,
                      },
                    }
                    : {
                      "& .MuiOutlinedInput-root": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d3d3d3",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#9395ec",
                        },
                      },
                    }),
                  ...sxTextField,
                }}
                onKeyDown={onKeyDown}
              />
            );
          }}
        ></Controller>
      </FormControl>
    </Grid>
  );
};

export default CustomTextField;
